import { render } from "./Island.vue?vue&type=template&id=6fff9339"
import script from "./Island.vue?vue&type=script&lang=js"
export * from "./Island.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Island.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fff9339"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fff9339', __exports__)) {
    api.reload('6fff9339', __exports__)
  }
  
  module.hot.accept("./Island.vue?vue&type=template&id=6fff9339", () => {
    api.rerender('6fff9339', render)
  })

}


export default __exports__